import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslation } from 'react-i18next';
import styles from './styles';
import warningAttention from '~/assets/dispatch/warning_attention.png';

const PF2MAlertDialog = ({
  classes,
  title,
  description,
  cancelText,
  confirmText,
  onClose,
  onConfirm,
  open,
  hasCancel,
  badge,
  classesContent,
  classesActions,
  classesButtons,
  confirmButtonProps,
  cancelButtonProps,
  content,
  container,
}) => {
  const { t: translate } = useTranslation();

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{ paper: classes.dialog }}
        scroll="body"
        container={container}
      >
        {badge && (
          <div className={classes.iconWrapper}>
            <img
              src={warningAttention}
              alt="Warning Attention"
              className={classes.icon}
            />
          </div>
        )}
        {title ? (
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        ) : null}
        <DialogContent className={`${classes.dialogContent} ${classesContent}`}>
          {description ? (
            <DialogContentText
              id="alert-dialog-description"
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {description}
            </DialogContentText>
          ) : null}
          {content}
        </DialogContent>
        <DialogActions className={classesActions}>
          {hasCancel ? (
            <Button
              onClick={onClose}
              variant="text"
              color="primary"
              {...cancelButtonProps}
              className={classNames(
                classesButtons,
                cancelButtonProps?.className,
              )}
            >
              {cancelText || translate('common:Cancel')}
            </Button>
          ) : null}
          <Button
            onClick={onConfirm}
            variant="contained"
            color="secondary"
            autoFocus
            {...confirmButtonProps}
            className={classNames(
              classesButtons,
              confirmButtonProps?.className,
            )}
          >
            {confirmText || translate('common:Exit')}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

PF2MAlertDialog.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  hasCancel: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  badge: PropTypes.bool,
  classesContent: PropTypes.string,
  classesActions: PropTypes.string,
  classesButtons: PropTypes.string,
  cancelButtonProps: PropTypes.object,
  confirmButtonProps: PropTypes.object,
  content: PropTypes.node,
  container: PropTypes.instanceOf(HTMLElement),
};

PF2MAlertDialog.defaultProps = {
  title: '',
  description: undefined,
  cancelText: undefined,
  confirmText: undefined,
  open: false,
  onClose: () => {},
  onConfirm: () => {},
  hasCancel: true,
  badge: false,
  classesContent: '',
  classesActions: '',
  classesButtons: '',
  confirmButtonProps: {},
  cancelButtonProps: {},
  content: undefined,
  container: undefined,
};

export default withStyles(styles)(PF2MAlertDialog);
